export const INVOICE_PAYMENT_METHOD_FILTERS = [
  'cash',
  'card',
  'mixed',
  'invoice',
  'bank_transfer',
  'mobile_pay',
  'online',
  'other',
] as const;

export type InvoicePaymentMethodFilter = (typeof INVOICE_PAYMENT_METHOD_FILTERS)[number];

const METHOD_ORDER = ['cash', 'card', 'bank_transfer', 'invoice', 'mobile_pay', 'online', 'other'] as const;

function sortPaymentMethods(methods: string[]): string[] {
  const unique = [...new Set(methods.filter((method) => method !== 'reversal'))];
  return unique.sort((a, b) => {
    const orderA = (METHOD_ORDER as readonly string[]).indexOf(a);
    const orderB = (METHOD_ORDER as readonly string[]).indexOf(b);
    const rankedA = orderA === -1 ? 99 : orderA;
    const rankedB = orderB === -1 ? 99 : orderB;
    return rankedA - rankedB || a.localeCompare(b);
  });
}

/**
 * Keys for the invoice list "Maksutapa" cell. Prefer the payment trail
 * (so cash+card checkout renders as two methods); fall back to the
 * denormalized invoices.paymentMethod, including `mixed`.
 */
export function invoicePaymentMethodKeys(item: {
  paymentMethod?: string | null;
  paymentMethods?: string[] | null;
}): string[] {
  const fromPayments = sortPaymentMethods(item.paymentMethods ?? []);
  if (fromPayments.length > 0) return fromPayments;
  if (item.paymentMethod) return [item.paymentMethod];
  return [];
}

/**
 * Default method when recording a payment from the invoice pages (#4113).
 * Once the invoice has gone out, the money normally arrives as the invoice
 * being paid to the workshop's account, so that is suggested first. A draft
 * is still at the counter, where card stays the default like at checkout.
 */
export function recordPaymentInitialMethod(status: string): 'invoice' | 'card' {
  return status === 'draft' ? 'card' : 'invoice';
}
